import { IssueViewerRegistry } from 'common/module_interface/RiskManagement/issues/IssueViewerRegistry';
import { Addin } from 'common/extensibility/AddinRegistry';
import { IProtectedAssetDetailProvider } from 'common/module_interface/assets/ProtectedAssets';
import { InfoPaneFieldProps } from 'common/components/InfoPane/InfoPane';
import { AssetFieldsMap } from 'common/module_interface/assets/AssetsConsts';

export const ISSUE_ASSET_PANEL_KEY = 'ISSUE_ASSET_PANEL';

export const initializeIssueAssetPanel = () => {
    const fieldAddins: Addin<IProtectedAssetDetailProvider<InfoPaneFieldProps>>[] = [
        {
            id: 'type',
            position: 20,
            content: AssetFieldsMap.typeField,
        },
        {
            id: 'id',
            position: 30,
            content: AssetFieldsMap.idField,
        },
        {
            id: 'organizationalUnit',
            position: 40,
            content: AssetFieldsMap.organizationalUnitField,
        },
        {
            id: 'environment',
            position: 50,
            content: AssetFieldsMap.environmentField,
        },
        {
            id: 'platform',
            position: 60,
            content: AssetFieldsMap.platformField,
        },
    ];
    IssueViewerRegistry.addFieldAddins(fieldAddins, ISSUE_ASSET_PANEL_KEY);
};
